module.exports = __webpack_public_path__ + "assets/c6f62ee353777c184590b5ad8d2a7aa8.png";